import { GeoJSONProperties } from '../hooks/useDealershipList';
import { PlaceResultType } from '../types/placeResultLocation';
import { calculateDistance } from './calculateDistance';
import { MARKET } from '../constants/market';

export interface getAvailableDealersProps {
  allDealersList: GeoJSON.FeatureCollection<GeoJSON.Point, GeoJSONProperties>;
  centerLocation: PlaceResultType;
  radius: number;
}

export const getAvailableDealers = ({
  allDealersList,
  centerLocation,
  radius,
}: getAvailableDealersProps): GeoJSON.Feature<GeoJSON.Point, GeoJSONProperties>[] => {
  const allDealers = JSON.parse(JSON.stringify(allDealersList)) as GeoJSON.FeatureCollection<
    GeoJSON.Point,
    GeoJSONProperties
  >; // Convert to plain JavaScript object

  const centerLat = centerLocation.geometry.location?.lat;
  const centerLng = centerLocation.geometry.location?.lng;

  if (centerLat === undefined || centerLng === undefined) {
    console.error('Center location coordinates are undefined');
    return [];
  }

  const radiusInKilometer = MARKET === 'CAN' ? radius : radius * 1.60934;

  const dealersWithinRadius = allDealers.features
    .map((dealer) => {
      const dealerLatLng = {
        lat: dealer.geometry.coordinates[1],
        lng: dealer.geometry.coordinates[0],
      };

      const distance = calculateDistance(centerLat, centerLng, dealerLatLng.lat, dealerLatLng.lng);
      return {
        ...dealer,
        distance, // Include the distance in the dealer object
      };
    })
    .filter((dealer) => dealer.distance <= radiusInKilometer)
    .sort((a, b) => (a.distance ?? 0) - (b.distance ?? 0));

  return dealersWithinRadius as GeoJSON.Feature<GeoJSON.Point, GeoJSONProperties>[];
};
